import React from "react";
import { Row, Col, Panel, Button, Table, Modal } from "react-bootstrap";
import AscComponent from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import * as GlobalConst from '../../components/AscConstants';
import InlineForm from "../Elements/FromGroup/InlineForm";
import { DropdownButton, MenuItem } from "react-bootstrap";
import BlockUi from "react-block-ui";
import SetDataWithSpeechBubble from "../Elements/AscElements/SetDataWithSpeechBubble";
import CallHistoryAnalysisSettingModal from './CallHistoryAnalysisSettingModal';

export default class CallHistoryAnalysisSetting extends AscComponent {
    constructor(props) {
        super(props);

        // 管理者権限がある場合は初期状態で会社が選択されていない状態にする
        const isAdmin = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);

        this.state = {
            company_id: isAdmin ? null : this.props.userInfo.company_id,
            company_name: isAdmin ? null : this.props.userInfo.company_name,
            companySelect: [],
            data: {},
            loading: false,
            blocking: false,
            show : false,
            callHistoryAnalysisSettingShow : true,
            originalData: {},
            hasUnsavedChanges: false
        };
    }

    componentDidMount = async () => {
        this._isMounted = true;
        await this.setCallEvalCompanySelect();
        
        // 会社管理者以下のユーザーの場合は自動的にデータを取得
        const isAdmin = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);
        if (!isAdmin && this.state.company_id) {
            await this.getBoardData();
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    // フォーム項目の無効化判定
    isFormDisabled = () => {
        // OEM管理者以上で、会社が選択されていないか、またはデータが取得されていない場合は無効化
        const isGreaterEqualOemAdmin = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);
        const isCompanyNotSelected = !this.state.company_id;
        const isDataNotLoaded = Object.keys(this.state.data).length === 0;
        const shouldDisable = isGreaterEqualOemAdmin && (isCompanyNotSelected || isDataNotLoaded);
        
        return shouldDisable;
    }

    getBoardData = async () => {
        try {
            if (!this._isMounted) return;
            
            // 会社が選択されていない場合は処理を中断
            if (!this.state.company_id) {
                return;
            }
            
            // ローディング状態を開始
            this.setState({ loading: true });
            
            const response = await this.ascAxios(`post`, `${this.reactContainerPath}/board`, {
                company_id: this.state.company_id
            });
            
            if (response && response.data && response.data.data) {
                if (this._isMounted) {
                    this.setState({
                        data: response.data.data,
                        originalData: { ...response.data.data },
                        hasUnsavedChanges: false,
                        loading: false
                    }, () => {
                        this.forceUpdate();
                    });
                }
            } else {
                if (this._isMounted) {
                    this.setState({ 
                        data: {},
                        originalData: {},
                        hasUnsavedChanges: false,
                        loading: false 
                    }, () => {
                        this.forceUpdate();
                    });
                    this.toast(this.props.langText.Message.GetDataError);
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    setCallEvalCompanySelect = async () => {
        const isAdmin = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);
        let initialCompanyId = '';
        if (!isAdmin) {
            // 一般ユーザーで company_id が設定されていない場合は、自分の会社を設定
            initialCompanyId = this.props.userInfo.company_id;
            if (this._isMounted) {
                this.setState({
                    company_id: initialCompanyId
                });
            }
        } else {
            try {
                // 応対品質分析オプションがonの会社のみを取得
                const response = await this.ascAxios("post", `${this.reactContainerPath}/getCallEvalCompanies`, {});
                
                if (response ) {
                    // 管理者権限がある場合は初期状態で会社が選択されていない状態を維持
                    // 一般ユーザーの場合は自分の会社で初期化
                    initialCompanyId = this.state.company_id;
                }
                if (this._isMounted) {
                    this.setState({
                        companySelect: response.data.data,
                        company_id: initialCompanyId
                    });
                }
            } catch (err) {
                console.error(err);
                this.showErrorObjectMesssage(err);
            }
        }
    }

    onSearchDataChange = (company_id) => {
        // 対応品質分析パラメータがonの会社の中から選択された会社のID
        const selectedCompany = this.state.companySelect.find(company => (company.value || company.id) === company_id);
        
        if (this._isMounted) {
            this.setState({
                company_name: selectedCompany.label,
                company_id: company_id
            }, () => {
                // フォーム無効化状態の変更に伴いエラーメッセージ表示を更新
                this.forceUpdate();
            });
        }
    }

    // 検索ボタンのハンドラーを追加
    onSearch = () => {
        this.getBoardData();
    }

    onChange = stateKey => event => {
        let value;
        if (event && event.target) {
            // 入力要素からの値
            value = event.target.value;
        } else if (event && event.value !== undefined) {
            // 選択要素からの値
            value = event.value;
        } else {
            value = event;
        }
        
        // 数値フィールドの場合は数値に変換（空文字の場合は空文字のまま）
        if (value !== "" && value !== null && value !== undefined && value.toString().trim() !== "") {
            const numValue = parseFloat(value);
            // 数値変換後も有効な数値の場合のみ変換
            if (!isNaN(numValue)) {
                value = numValue;
            }
        }
        
        if (this._isMounted) {
            let newData = {
                ...this.state.data,
                [stateKey]: value
            };
            
            // 無音判定秒数が0の場合、無音減点数も0に設定
            if (stateKey === 'seconds_determine_silence' && value === 0) {
                newData.minus_score_silence = 0;
            }
            
            // 重なり判定秒数が0の場合、重なり減点数も0に設定
            if (stateKey === 'seconds_determine_conflict' && value === 0) {
                newData.minus_score_conflict = 0;
            }
            
            this.setState({
                data: newData
            }, () => {
                // リアルタイムでバリデーション状態を更新
                const hasDiff = this.isDataDifferent(
                    this.getComparableData(this.state.originalData),
                    this.getComparableData(this.state.data)
                );
                this.setState({ hasUnsavedChanges: hasDiff });
                this.forceUpdate();
            });
        }
    }

    // 比較対象のキーのみ抽出
    getComparableData = (src) => {
        const keys = [
            'score_min',
            'score_max',
            'score_base',
            'score_talk_minutes_less_than_1',
            'score_talk_minutes_1_to_3',
            'score_talk_minutes_3_to_5',
            'score_talk_minutes_5_to_10',
            'score_talk_minutes_10_to_20',
            'score_talk_minutes_20_to_30',
            'score_talk_minutes_30_to_40',
            'score_talk_minutes_40_to_50',
            'score_talk_minutes_50_to_60',
            'score_talk_minutes_60_or_more',
            'goal_op_talk_per',
            'minus_score_op_talk_per_every_1per_deviation',
            'seconds_determine_silence',
            'minus_score_silence',
            'seconds_determine_conflict',
            'minus_score_conflict'
        ];
        const out = {};
        keys.forEach(k => {
            let v = src && Object.prototype.hasOwnProperty.call(src, k) ? src[k] : undefined;
            if (v === '') v = undefined; // 空文字は未設定と同義に
            out[k] = v;
        });
        return out;
    }

    // オブジェクト差分判定（シリアライズ比較）
    isDataDifferent = (a, b) => {
        try {
            return JSON.stringify(a) !== JSON.stringify(b);
        } catch (e) {
            return true;
        }
    }

    // マイナス値を許可する数値入力制御
    onKeyDownIntCheckWithMinus = (e) => {
        if (
            (e.keyCode >= 48 && e.keyCode <= 57) ||  // 数字キー 0-9
            (e.keyCode >= 96 && e.keyCode <= 105) || // テンキー 0-9
            e.keyCode === 8 ||   // バックスペース
            e.keyCode === 46 ||  // 削除
            e.keyCode === 9 ||   // タブ
            e.keyCode === 16 ||  // シフト
            e.keyCode === 189 || // マイナス記号（-）
            e.keyCode === 109 || // テンキーのマイナス記号（-）
            (e.keyCode >= 37 && e.keyCode <= 40) // 矢印キー
        ) {
            return true;
        } else if (e.ctrlKey) {
            if (e.keyCode === 67 || e.keyCode === 86) { // コピー・貼り付け
                return true;
            }
        } else {
            e.preventDefault();
            return false;
        }
    }

    // バリデーション機能
    validateFormData = () => {
        // フォームが無効化されている場合はバリデーションをスキップ
        if (this.isFormDisabled()) {
            return [];
        }
        
        const { data } = this.state;
        const errors = [];
        const errorMessages = this.props.langText.Message.CallHistoryAnalysisErrors;
        
        // 必須項目の空文字チェック
        const requiredFields = [
            'score_min',
            'score_max',
            'score_base',
            'goal_op_talk_per',
            'minus_score_op_talk_per_every_1per_deviation',
            'seconds_determine_silence',
            'minus_score_silence',
            'seconds_determine_conflict',
            'minus_score_conflict'
        ];
            
        requiredFields.forEach(field => {
            if (data[field] === undefined || data[field] === null || data[field] === '') {
                errors.push(this.sprintf(errorMessages.requiredFieldsMessage, errorMessages.requiredFields[field]));
            }
        });
        
        // 通話時間による加減点の必須チェック
        const talkTimeField = [
            'score_talk_minutes_less_than_1',
            'score_talk_minutes_1_to_3',
            'score_talk_minutes_3_to_5',
            'score_talk_minutes_5_to_10',
            'score_talk_minutes_10_to_20',
            'score_talk_minutes_20_to_30',
            'score_talk_minutes_30_to_40',
            'score_talk_minutes_40_to_50',
            'score_talk_minutes_50_to_60',
            'score_talk_minutes_60_or_more'
        ];
        
        talkTimeField.forEach(field => {
            if (data[field] === undefined || data[field] === null || data[field] === '') {
                errors.push(this.sprintf(errorMessages.requiredFieldsMessage, errorMessages.talkTimeFieldsForValidation[field]));
            }
        });
        
        // 数値の範囲チェック（値が入力されている場合のみ）
        if (data.score_min !== undefined && data.score_min !== null && data.score_min !== '' &&
            data.score_max !== undefined && data.score_max !== null && data.score_max !== '' &&
            data.score_min >= data.score_max) {
            errors.push(this.sprintf(errorMessages.defaultRange, errorMessages.minRequired, errorMessages.LessThanMax, "0", "999"));
        }
        
        if (data.score_base !== undefined && data.score_base !== null && data.score_base !== '' &&
            data.score_min !== undefined && data.score_min !== null && data.score_min !== '' &&
            data.score_base < data.score_min) {
            errors.push(this.sprintf(errorMessages.defaultRange, errorMessages.baseRequired, errorMessages.GreaterThanMinAndLessThanMax, "0", "999"));
        }
        
        if (data.score_base !== undefined && data.score_base !== null && data.score_base !== '' &&
            data.score_max !== undefined && data.score_max !== null && data.score_max !== '' &&
            data.score_base > data.score_max) {
            errors.push(this.sprintf(errorMessages.defaultRange, errorMessages.baseRequired, errorMessages.GreaterThanMinAndLessThanMax, "0", "999"));
        }
        
        // 通話時間による加減点の範囲チェック
        talkTimeField.forEach(field => {
            const value = data[field];
            if (value !== undefined && value !== null && value !== '') {
                // 基準点を基準にしたバリデーション
                const baseScore = data.score_base;
                const minScore = data.score_min;
                const maxScore = data.score_max;
                
                if (baseScore !== undefined && baseScore !== null && baseScore !== '' &&
                    minScore !== undefined && minScore !== null && minScore !== '' &&
                    maxScore !== undefined && maxScore !== null && maxScore !== '') {
                    
                    const totalScore = parseInt(value) + parseInt(baseScore);
                    
                    if (totalScore < minScore || totalScore > maxScore) {
                        errors.push(this.sprintf(errorMessages.defaultRange, errorMessages.talkTimeRequired, errorMessages.plusBaseIsGreaterThanMinAndLessThanMax, "-50", "50"));
                    }
                }
            }
        });
        
        return errors;
    }

    // 他の画面と統一したバリデーション処理
    validationHandle = (param) => {
        // フォームが無効化されている場合はエラー表示しない
        if (this.isFormDisabled()) {
            return null;
        }
        
        let nowState = null;
        const { data } = this.state;
        
        switch (param) {
            case 'score_min':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                if (data.score_min === undefined || data.score_min === null || data.score_min === '') {
                    nowState = 'error';
                } else if (data.score_min < 0 || data.score_min > 999) {
                    // 0～999の範囲チェック
                    nowState = 'error';
                } else {
                    // 最大値が入力されている場合のみ比較
                    let isValid = true;
                    
                    // 最大値との比較（最大値が入力されている場合のみ）
                    if (data.score_max !== undefined && data.score_max !== null && data.score_max !== '' && 
                        data.score_min >= data.score_max) {
                        isValid = false;
                    }
                    
                    nowState = isValid ? null : 'error';
                }
                break;
            case 'score_max':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                if (data.score_max === undefined || data.score_max === null || data.score_max === '') {
                    nowState = 'error';
                } else if (data.score_max < 0 || data.score_max > 999) {
                    // 0～999の範囲チェック
                    nowState = 'error';
                } else {
                    // 最小値が入力されている場合のみ比較
                    let isValid = true;
                    
                    // 最小値との比較（最小値が入力されている場合のみ）
                    if (data.score_min !== undefined && data.score_min !== null && data.score_min !== '' && 
                        data.score_max <= data.score_min) {
                        isValid = false;
                    }
                    
                    nowState = isValid ? null : 'error';
                }
                break;
            case 'score_base':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                if (data.score_base === undefined || data.score_base === null || data.score_base === '') {
                    nowState = 'error';
                } else if (data.score_base < 0 || data.score_base > 999) {
                    // 0～999の範囲チェック
                    nowState = 'error';
                } else {
                    // 最小値・最大値が入力されている場合のみ比較
                    let isValid = true;
                    
                    // 最小値との比較（最小値が入力されている場合のみ）
                    if (data.score_min !== undefined && data.score_min !== null && data.score_min !== '' && 
                        data.score_base < data.score_min) {
                        isValid = false;
                    }
                    
                    // 最大値との比較（最大値が入力されている場合のみ）
                    if (data.score_max !== undefined && data.score_max !== null && data.score_max !== '' && 
                        data.score_base > data.score_max) {
                        isValid = false;
                    }
                    
                    nowState = isValid ? null : 'error';
                }
                break;
            case 'goal_op_talk_per':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                nowState = (data.goal_op_talk_per !== undefined && data.goal_op_talk_per !== null && data.goal_op_talk_per !== '' && 
                           data.goal_op_talk_per >= 0 && data.goal_op_talk_per <= 100) ? null : 'error';
                break;
            case 'minus_score_op_talk_per_every_1per_deviation':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                nowState = (data.minus_score_op_talk_per_every_1per_deviation !== undefined && 
                           data.minus_score_op_talk_per_every_1per_deviation !== null && 
                           data.minus_score_op_talk_per_every_1per_deviation !== '' && 
                           data.minus_score_op_talk_per_every_1per_deviation >= -999 && 
                           data.minus_score_op_talk_per_every_1per_deviation <= -1) ? null : 'error';
                break;
            case 'seconds_determine_silence':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                nowState = (data.seconds_determine_silence !== undefined && data.seconds_determine_silence !== null && data.seconds_determine_silence !== '' && 
                           data.seconds_determine_silence >= 0 && data.seconds_determine_silence <= 999) ? null : 'error';
                break;
            case 'minus_score_silence':
                // 無音判定秒数が0の場合はバリデーションスキップ
                if (data.seconds_determine_silence === 0) {
                    nowState = null;
                } else {
                    // 空文字、undefined、nullの場合もエラー表示（必須入力）
                    nowState = (data.minus_score_silence !== undefined && data.minus_score_silence !== null && data.minus_score_silence !== '' && 
                               data.minus_score_silence >= -999 && data.minus_score_silence <= -1) ? null : 'error';
                }
                break;
            case 'seconds_determine_conflict':
                // 空文字、undefined、nullの場合もエラー表示（必須入力）
                nowState = (data.seconds_determine_conflict !== undefined && data.seconds_determine_conflict !== null && data.seconds_determine_conflict !== '' && 
                           data.seconds_determine_conflict >= 0 && data.seconds_determine_conflict <= 999) ? null : 'error';
                break;
            case 'minus_score_conflict':
                // 重なり判定秒数が0の場合はバリデーションスキップ
                if (data.seconds_determine_conflict === 0) {
                    nowState = null;
                } else {
                    // 空文字、undefined、nullの場合もエラー表示（必須入力）
                    nowState = (data.minus_score_conflict !== undefined && data.minus_score_conflict !== null && data.minus_score_conflict !== '' && 
                               data.minus_score_conflict >= -999 && data.minus_score_conflict <= -1) ? null : 'error';
                }
                break;
            default:
                // 通話時間による加減点のバリデーション
                const talkTimeFieldsForValidationHandle = [
                    'score_talk_minutes_less_than_1',
                    'score_talk_minutes_1_to_3',
                    'score_talk_minutes_3_to_5',
                    'score_talk_minutes_5_to_10',
                    'score_talk_minutes_10_to_20',
                    'score_talk_minutes_20_to_30',
                    'score_talk_minutes_30_to_40',
                    'score_talk_minutes_40_to_50',
                    'score_talk_minutes_50_to_60',
                    'score_talk_minutes_60_or_more'
                ];
                
                if (talkTimeFieldsForValidationHandle.includes(param)) {
                    const value = data[param];
                    // 空文字、undefined、nullの場合もエラー表示（必須入力）
                    if (value === undefined || value === null || value === '') {
                        nowState = 'error';
                    } else if (value < -999 || value > 999) {
                        // -999～999の範囲チェック
                        nowState = 'error';
                    } else {
                        // 基準点を基準にしたバリデーション
                        const baseScore = data.score_base;
                        const minScore = data.score_min;
                        const maxScore = data.score_max;
                        
                        // 基準点、最小値、最大値が入力されている場合のみ合計値チェック
                        if (baseScore !== undefined && baseScore !== null && baseScore !== '' &&
                            minScore !== undefined && minScore !== null && minScore !== '' &&
                            maxScore !== undefined && maxScore !== null && maxScore !== '') {
                            
                            const totalScore = parseInt(value) + parseInt(baseScore);
                            
                            // 入力値 + 基準点が最小値～最大値の範囲内にあるかチェック（等号を含む）
                            if (totalScore < minScore || totalScore > maxScore) {
                                nowState = 'error';
                            } else {
                                nowState = null;
                            }
                        } else {
                            // 基準点、最小値、最大値のいずれかが未入力の場合はエラーなし
                            nowState = null;
                        }
                    }
                }
                break;
        }
        return nowState;
    }

    // リアルタイムバリデーション（他の画面と統一）
    onBlurValidation = (fieldName) => {
        // フォームが無効化されている場合はバリデーションをスキップ
        if (this.isFormDisabled()) {
            return;
        }
        
        const validationState = this.validationHandle(fieldName);
        if (validationState === 'error') {
            this.toast(this.sprintf(this.props.langText.Message.CallHistoryAnalysisErrors.noneInputError, fieldName));
        }
    }
    
    // 設定保存処理
    saveSetting = async () => {
        try {
            this.blockUI();
            
            const { data } = this.state;
            
            // 保存データを準備
            const saveData = {
                cm12_id: this.state.company_id,
                score_min: data.score_min,
                score_max: data.score_max,
                score_base: data.score_base,
                score_talk_minutes_less_than_1: data.score_talk_minutes_less_than_1,
                score_talk_minutes_1_to_3: data.score_talk_minutes_1_to_3,
                score_talk_minutes_3_to_5: data.score_talk_minutes_3_to_5,
                score_talk_minutes_5_to_10: data.score_talk_minutes_5_to_10,
                score_talk_minutes_10_to_20: data.score_talk_minutes_10_to_20,
                score_talk_minutes_20_to_30: data.score_talk_minutes_20_to_30,
                score_talk_minutes_30_to_40: data.score_talk_minutes_30_to_40,
                score_talk_minutes_40_to_50: data.score_talk_minutes_40_to_50,
                score_talk_minutes_50_to_60: data.score_talk_minutes_50_to_60,
                score_talk_minutes_60_or_more: data.score_talk_minutes_60_or_more,
                goal_op_talk_per: data.goal_op_talk_per,
                minus_score_op_talk_per_every_1per_deviation: data.minus_score_op_talk_per_every_1per_deviation,
                seconds_determine_silence: data.seconds_determine_silence,
                minus_score_silence: data.minus_score_silence,
                seconds_determine_conflict: data.seconds_determine_conflict,
                minus_score_conflict: data.minus_score_conflict
            };
            
            // サーバーに保存リクエストを送信
            this
                .ascAxios('post', `${this.reactContainerPath}/update`, saveData)
                .then(res => {
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.onSearch();
                    this.setState({show : false});
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                    this.onSearch();
                    this.setState({ show : false });
                });
        } catch (error) {
            console.error(error);
            this.showErrorObjectMesssage(error);
        } finally {
            this.unblockUI();
        }
    }

    // モーダル制御関数
    modalShow = () => () => {
        try {
            if (!this.state.company_id) return;
            this.setState({
                show: true,
                modalType: 'update'
            });
        } catch (err) {
            console.error(err);
        }
    }
    
    // 更新ボタンの非活性判定
    isUpdateButtonDisabled = () => {
        // ローディング中は非活性
        if (this.state.loading) {
            return true;
        }
        
        // 会社が選択されていない場合は非活性
        if (!this.state.company_id) {
            return true;
        }
        
        // データが取得されていない場合は非活性
        if (Object.keys(this.state.data).length === 0) {
            return true;
        }
        
        // 未保存の変更がない場合は非活性
        if (!this.state.hasUnsavedChanges) {
            return true;
        }

        // フォームバリデーションでエラーがある場合は非活性
        const errors = this.validateFormData();
        if (errors.length > 0) {
            return true;
        }
        
        return false;
    }

    isSearchButtonDisabled = () => {
        // ローディング中は非活性
        if (this.state.loading) {
            return true;
        }
        
        // 会社が選択されていない場合は非活性
        if (!this.state.company_id) {
            return true;
        }
    }
    
    // エラーメッセージを取得する関数
    getBlockErrorMessage = (blockType) => {
        // フォームが無効化されている場合はエラーメッセージを表示しない
        if (this.isFormDisabled()) {
            return [];
        }
        
        const { data } = this.state;
        const errors = [];
        const errorMessages = this.props.langText.Message.CallHistoryAnalysisErrors;
        
        switch (blockType) {
            case 'range':
                // 空白チェック
                const minEmpty = data.score_min === undefined || data.score_min === null || data.score_min === '';
                const maxEmpty = data.score_max === undefined || data.score_max === null || data.score_max === '';
                
                if (minEmpty && maxEmpty) {
                    // 両方空白の場合
                    errors.push(errorMessages.rangeEmptyBothError);
                    errors.push(`${errorMessages.minRequired} : ${errorMessages.rangeEmptyMinErrorSubtext}`);
                    errors.push(`${errorMessages.maxRequired} : ${errorMessages.rangeEmptyMaxErrorSubtext}`);
                } else if (minEmpty) {
                    // 最小値のみ空白の場合
                    errors.push(errorMessages.rangeEmptyMinError);
                    errors.push(errorMessages.rangeEmptyMinErrorSubtext);
                } else if (maxEmpty) {
                    // 最大値のみ空白の場合
                    errors.push(errorMessages.rangeEmptyMaxError);
                    errors.push(errorMessages.rangeEmptyMaxErrorSubtext);
                } else {
                    // 両方値が入力されている場合の条件チェック
                    if (
                        data.score_min >= data.score_max ||
                        data.score_min < 0 ||
                        data.score_min > 999 ||
                        data.score_max < 0 ||
                        data.score_max > 999
                    ) {
                        // 最小値=最大値または最小値>最大値の場合
                        errors.push(`${errorMessages.minRequired} : ${errorMessages.rangeEmptyMinErrorSubtext}`);
                        errors.push(`${errorMessages.maxRequired} : ${errorMessages.rangeEmptyMaxErrorSubtext}`);
                    }
                }
                break;
            case 'base':
                // 空白チェック
                const baseEmpty = data.score_base === undefined || data.score_base === null || data.score_base === '';
                
                if (baseEmpty) {
                    // 空白の場合
                    errors.push(errorMessages.baseEmptyError);
                    errors.push(errorMessages.baseEmptyErrorSubtext);
                } else {
                    // 値が入力されている場合の条件チェック
                    const minScore = data.score_min;
                    const maxScore = data.score_max;
                    
                    // 設定可能範囲チェック（最小値以上、最大値以下）
                    if ((minScore !== undefined && minScore !== null && minScore !== '' && data.score_base < minScore) ||
                        (maxScore !== undefined && maxScore !== null && maxScore !== '' && data.score_base > maxScore)) {
                        errors.push(errorMessages.baseRelationError);
                    }
                }
                break;
            case 'talkTime':
                // 通話時間フィールドのエラーチェック
                const talkTimeFields = [
                    { key: 'score_talk_minutes_less_than_1'},
                    { key: 'score_talk_minutes_1_to_3'},
                    { key: 'score_talk_minutes_3_to_5'},
                    { key: 'score_talk_minutes_5_to_10'},
                    { key: 'score_talk_minutes_10_to_20'},
                    { key: 'score_talk_minutes_20_to_30'},
                    { key: 'score_talk_minutes_30_to_40'},
                    { key: 'score_talk_minutes_40_to_50'},
                    { key: 'score_talk_minutes_50_to_60'},
                    { key: 'score_talk_minutes_60_or_more'}
                ];
                
                let hasEmptyFields = false;
                let hasRangeErrors = false;
                let hasCalculationErrors = false;
                
                // 設定可能範囲を計算
                const talkTimeRange = this.calculateTalkTimeRange();
                
                talkTimeFields.forEach(field => {
                    const value = data[field.key];
                    if (value === undefined || value === null || value === '') {
                        hasEmptyFields = true;
                    } else {
                        const numValue = parseFloat(value);
                        
                        // 基本的な範囲チェック（-999～999）
                        if (numValue < -999 || numValue > 999) {
                            hasRangeErrors = true;
                        }
                        
                        // 実際の設定可能範囲チェック（calculateTalkTimeRangeの結果を使用）
                        if (talkTimeRange.hasRange) {
                            if (numValue < talkTimeRange.min || numValue > talkTimeRange.max) {
                                hasCalculationErrors = true;
                            }
                        }
                    }
                });
                
                // 基準値、最小値、最大値がすべて正しく入力されているかチェック
                const baseScore = data.score_base;
                const minScore = data.score_min;
                const maxScore = data.score_max;
                const isAllBaseDataValid = baseScore !== undefined && baseScore !== null && baseScore !== '' &&
                                         minScore !== undefined && minScore !== null && minScore !== '' &&
                                         maxScore !== undefined && maxScore !== null && maxScore !== '';
                
                if (hasEmptyFields) {
                    // 空白がある場合
                    errors.push(errorMessages.talkTimeEmptyError);
                    errors.push(errorMessages.talkTimeErrorSubtext1);
                    errors.push(errorMessages.talkTimeErrorSubtext2);
                    errors.push(errorMessages.talkTimeErrorSubtext3);
                    if (isAllBaseDataValid && talkTimeRange.hasRange) {
                        errors.push(this.sprintf(errorMessages.talkTimeErrorSubtext4, talkTimeRange.min, talkTimeRange.max));
                    }
                } else if (hasRangeErrors || hasCalculationErrors) {
                    // 範囲外の場合
                    errors.push(errorMessages.talkTimeRangeError);
                    errors.push(errorMessages.talkTimeErrorSubtext1);
                    errors.push(errorMessages.talkTimeErrorSubtext2);
                    errors.push(errorMessages.talkTimeErrorSubtext3);
                    if (isAllBaseDataValid && talkTimeRange.hasRange) {
                        errors.push(this.sprintf(errorMessages.talkTimeErrorSubtext4, talkTimeRange.min, talkTimeRange.max));
                    }
                }
                break;
            case 'opRatio':
                // OP通話率設定のエラーチェック
                const goalEmpty = data.goal_op_talk_per === undefined || data.goal_op_talk_per === null || data.goal_op_talk_per === '';
                const deviationEmpty = data.minus_score_op_talk_per_every_1per_deviation === undefined || data.minus_score_op_talk_per_every_1per_deviation === null || data.minus_score_op_talk_per_every_1per_deviation === '';
                
                if (goalEmpty && deviationEmpty) {
                    // 両方空白の場合
                    errors.push(errorMessages.opRatioEmptyBothError);
                    errors.push(errorMessages.opRatioEmptyBothErrorSubtext1);
                    errors.push(errorMessages.opRatioEmptyBothErrorSubtext2);
                } else if (goalEmpty) {
                    // 目標値のみ空白の場合
                    errors.push(errorMessages.opRatioEmptyTargetError);
                    errors.push(errorMessages.opRatioEmptyTargetErrorSubtext);
                } else if (deviationEmpty) {
                    // 減点数のみ空白の場合
                    errors.push(errorMessages.opRatioEmptyScoreError);
                    errors.push(errorMessages.opRatioEmptyScoreErrorSubtext);
                } else {
                    // 両方値が入力されている場合の範囲チェック
                    let hasTargetRangeError = data.goal_op_talk_per < 0 || data.goal_op_talk_per > 100;
                    let hasScoreRangeError = data.minus_score_op_talk_per_every_1per_deviation < -999 || data.minus_score_op_talk_per_every_1per_deviation > -1;
                    
                    if (hasTargetRangeError && hasScoreRangeError) {
                        // 両方範囲外の場合
                        errors.push(errorMessages.opRatioEmptyBothError);
                        errors.push(errorMessages.opRatioEmptyBothErrorSubtext1);
                        errors.push(errorMessages.opRatioEmptyBothErrorSubtext2);
                    } else if (hasTargetRangeError) {
                        // 目標値のみ範囲外の場合
                        errors.push(errorMessages.opRatioEmptyTargetError);
                        errors.push(errorMessages.opRatioEmptyTargetErrorSubtext);
                    } else if (hasScoreRangeError) {
                        // 減点数のみ範囲外の場合
                        errors.push(errorMessages.opRatioEmptyScoreError);
                        errors.push(errorMessages.opRatioEmptyScoreErrorSubtext);
                    }
                }
                break;
            case 'silence':
                // 無音判定設定のエラーチェック
                const silenceSecondsEmpty = data.seconds_determine_silence === undefined || data.seconds_determine_silence === null || data.seconds_determine_silence === '';
                const silenceScoreEmpty = data.minus_score_silence === undefined || data.minus_score_silence === null || data.minus_score_silence === '';
                const isSilenceSecondsZero = data.seconds_determine_silence === 0;
                
                // パラメータ0に設定した場合の表示
                if (isSilenceSecondsZero) {
                    errors.push(errorMessages.silenceDisabledMessage);
                }
                
                if (silenceSecondsEmpty && silenceScoreEmpty) {
                    // 両方空白の場合
                    errors.push(errorMessages.silenceEmptyBothError);
                    errors.push(errorMessages.silenceEmptyBothErrorSubtext1);
                    errors.push(errorMessages.silenceEmptyBothErrorSubtext2);
                    errors.push(errorMessages.silenceDisabledMessage);
                } else if (silenceSecondsEmpty) {
                    // 判定秒数のみ空白の場合
                    errors.push(errorMessages.silenceEmptySecondsError);
                    errors.push(errorMessages.silenceEmptySecondsErrorSubtext1);
                    errors.push(errorMessages.silenceDisabledMessage);
                } else if (!isSilenceSecondsZero && silenceScoreEmpty) {
                    // 減点数のみ空白の場合（判定秒数が0でない場合）
                    errors.push(errorMessages.silenceEmptyScoreError);
                    errors.push(errorMessages.silenceEmptyScoreErrorSubtext);
                } else if (!silenceSecondsEmpty && !silenceScoreEmpty) {
                    // 両方値が入力されている場合の範囲チェック
                    let hasSecondsRangeError = data.seconds_determine_silence < 0 || data.seconds_determine_silence > 999;
                    let hasScoreRangeError = !isSilenceSecondsZero && (data.minus_score_silence < -999 || data.minus_score_silence > -1);
                    
                    if (hasSecondsRangeError && hasScoreRangeError) {
                        // 両方範囲外の場合
                        errors.push(errorMessages.silenceEmptyBothError);
                        errors.push(errorMessages.silenceEmptyBothErrorSubtext1);
                        errors.push(errorMessages.silenceEmptyBothErrorSubtext2);
                        errors.push(errorMessages.silenceDisabledMessage);
                    } else if (hasSecondsRangeError) {
                        // 判定秒数のみ範囲外の場合
                        errors.push(errorMessages.silenceEmptySecondsError);
                        errors.push(errorMessages.silenceEmptySecondsErrorSubtext1);
                        errors.push(errorMessages.silenceDisabledMessage);
                    } else if (hasScoreRangeError) {
                        // 減点数のみ範囲外の場合
                        errors.push(errorMessages.silenceEmptyScoreError);
                        errors.push(errorMessages.silenceEmptyScoreErrorSubtext);
                    }
                }
                break;
            case 'conflict':
                // 重なり判定設定のエラーチェック
                const conflictSecondsEmpty = data.seconds_determine_conflict === undefined || data.seconds_determine_conflict === null || data.seconds_determine_conflict === '';
                const conflictScoreEmpty = data.minus_score_conflict === undefined || data.minus_score_conflict === null || data.minus_score_conflict === '';
                const isConflictSecondsZero = data.seconds_determine_conflict === 0;
                
                // パラメータ0に設定した場合の表示
                if (isConflictSecondsZero) {
                    errors.push(errorMessages.conflictDisabledMessage);
                }
                
                if (conflictSecondsEmpty && conflictScoreEmpty) {
                    // 両方空白の場合
                    errors.push(errorMessages.conflictEmptyBothError);
                    errors.push(errorMessages.conflictEmptyBothErrorSubtext1);
                    errors.push(errorMessages.conflictEmptyBothErrorSubtext2);
                    errors.push(errorMessages.conflictDisabledMessage);
                } else if (conflictSecondsEmpty) {
                    // 判定秒数のみ空白の場合
                    errors.push(errorMessages.conflictEmptySecondsError);
                    errors.push(errorMessages.conflictEmptySecondsErrorSubtext1);
                    errors.push(errorMessages.conflictDisabledMessage);
                } else if (!isConflictSecondsZero && conflictScoreEmpty) {
                    // 減点数のみ空白の場合（判定秒数が0でない場合）
                    errors.push(errorMessages.conflictEmptyScoreError);
                    errors.push(errorMessages.conflictEmptyScoreErrorSubtext);
                } else if (!conflictSecondsEmpty && !conflictScoreEmpty) {
                    // 両方値が入力されている場合の範囲チェック
                    let hasSecondsRangeError = data.seconds_determine_conflict < 0 || data.seconds_determine_conflict > 999;
                    let hasScoreRangeError = !isConflictSecondsZero && (data.minus_score_conflict < -999 || data.minus_score_conflict > -1);
                    
                    if (hasSecondsRangeError && hasScoreRangeError) {
                        // 両方範囲外の場合
                        errors.push(errorMessages.conflictEmptyBothError);
                        errors.push(errorMessages.conflictEmptyBothErrorSubtext1);
                        errors.push(errorMessages.conflictEmptyBothErrorSubtext2);
                        errors.push(errorMessages.conflictDisabledMessage);
                    } else if (hasSecondsRangeError) {
                        // 判定秒数のみ範囲外の場合
                        errors.push(errorMessages.conflictEmptySecondsError);
                        errors.push(errorMessages.conflictEmptySecondsErrorSubtext1);
                        errors.push(errorMessages.conflictDisabledMessage);
                    } else if (hasScoreRangeError) {
                        // 減点数のみ範囲外の場合
                        errors.push(errorMessages.conflictEmptyScoreError);
                        errors.push(errorMessages.conflictEmptyScoreErrorSubtext);
                    }
                }
                break;
        }
        
        return errors;
    }
    
    // エラーメッセージコンポーネントを表示する関数
    renderBlockErrorMessage = (blockType) => {
        const errors = this.getBlockErrorMessage(blockType);
        if (errors.length === 0) return null;
        
        return (
            <div className="block-error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                {errors.map((error, index) => (
                    <div key={index}>{error}</div>
                ))}
            </div>
        );
    }
    
    // 通話時間による加減点の設定可能範囲を計算する関数
    calculateTalkTimeRange = () => {
        const { data } = this.state;
        const baseScore = data.score_base;
        const minScore = data.score_min;
        const maxScore = data.score_max;
        
        // 基準点、最小値、最大値が全て設定されている場合のみ計算
        if (baseScore !== undefined && baseScore !== null && baseScore !== '' &&
            minScore !== undefined && minScore !== null && minScore !== '' &&
            maxScore !== undefined && maxScore !== null && maxScore !== '') {
            
            const calcMin = minScore - baseScore;
            const calcMax = maxScore - baseScore;

            return {
                min: calcMin,
                max: calcMax,
                hasRange: true,
            };
        }

        return {
            hasRange: false
        };
    }
    


    getAnalysisSettingCompanyItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // 会社名
        itemArr.push(
            <Col xs={1} className="margin-top-1" key="company-label">
                {langText.Body.CompanyName}
            </Col>
        );

        // OEM以上は会社選択表示
        const isGreaterEqualOemAdmin = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem);
        
        if (isGreaterEqualOemAdmin) {
            // OEM以上は会社選択表示（応対品質分析オプションがonの会社のみ）
            let companyMenuItems = [];
            
            companyMenuItems = this.state.companySelect.map((company, index) => {
                // 会社名を取得（サーバー側はlabelフィールドで返す）
                const companyName = company.label;
                const companyId = company.value;
                
                return (
                    <MenuItem key={companyId} eventKey={companyId} title={companyName}>
                        <span className="dropdown-text-container">
                            {companyName}
                        </span>
                    </MenuItem>
                );
            });
            
            // 選択された会社の名前を取得
            const selectedCompany = this.state.companySelect.find(company => (company.value) === this.state.company_id);
            
            let selectedCompanyName = '';
            if (selectedCompany) {
                selectedCompanyName = selectedCompany.label;
            } else {
                selectedCompanyName = langText.Body.Cautioncompanyselect;
            }
            
            itemArr.push(
                <Col sm={12} md={3} lg={2} className="margin-top-03 template-dropdown" key="company-select">
                    <DropdownButton
                        id='dropdown'
                        title={selectedCompanyName}
                        className="margin-right-05"
                        onSelect={this.onSearchDataChange}>
                        {companyMenuItems}
                    </DropdownButton>
                </Col>
            );
            itemArr.push(
                <Col sm={12} md={8} lg={6} className="margin-top-03" key="search-button-area">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            id="customer-insert"
                            className="searchBtn"
                            bsStyle='primary'
                            bsSize='sm'
                            onClick={e => this.onSearch(e)}
                            disabled={this.isSearchButtonDisabled()}
                        >
                            {this.props.langText.Body.Search}
                        </Button>
                        {(() => {
                            const isDataNotLoaded = Object.keys(this.state.data).length === 0;
                            if (this.state.companySelect.length === 0) {
                                // 対応品質分析パラメータがonの会社がありません
                                return (
                                    <span style={{ 
                                        color: '#d9534f', 
                                        fontSize: '14px', 
                                        marginLeft: '15px',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        ＊{langText.Message.CallHistoryAnalysisErrors.noOptionCompanyMessage}
                                    </span>
                                );
                            } else if (!this.state.company_id) {
                                // 会社が選択されていない場合
                                return (
                                    <span style={{ 
                                        color: '#d9534f', 
                                        fontSize: '14px', 
                                        marginLeft: '15px',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        ＊{langText.Body.SettingValueDescription}
                                    </span>
                                );
                            } else if (this.state.company_id && isDataNotLoaded) {
                                // 会社は選択されているがデータが未取得の場合
                                return (
                                    <span style={{ 
                                        color: '#d9534f', 
                                        fontSize: '14px', 
                                        marginLeft: '15px',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        ＊{langText.Body.SettingValueDescription}
                                    </span>
                                );
                            } else if (this.state.hasUnsavedChanges) {
                                // 未保存の変更がある場合
                                return (
                                    <span style={{ 
                                        color: '#d9534f', 
                                        fontSize: '14px', 
                                        marginLeft: '15px',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        ＊{this.props.langText.Body.UnsavedChangesPrompt}
                                    </span>
                                );
                            }
                            return null;
                        })()}
                    </div>
                </Col>
            );
        } else {
            // 会社管理者権限以下の場合はログインユーザーの所属会社名を表示
            itemArr.push(
                <Col xs={2} md={2} className="margin-top-1" key="company-name">
                    <span title={this.props.userInfo.company_name}>
                        {this.props.userInfo.company_name}
                    </span>
                </Col>
            );
            if (this.state.hasUnsavedChanges) {
                itemArr.push(
                    <Col xs={2} md={2} className="margin-top-1">
                        {(() => {
                                    // 未保存の変更がある場合
                                    return (
                                        <span style={{ 
                                            color: '#d9534f', 
                                            fontSize: '14px', 
                                            marginLeft: '15px',
                                            fontWeight: 'normal',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            ＊{this.props.langText.Body.UnsavedChangesPrompt}
                                        </span>
                                    );
                                })()}
                    </Col>
                )
            }
        }

        return itemArr;
    }

    getAnalysisSettingRangeItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // 最小値
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="min-score">
                <InlineForm
                    label={langText.Body.SettingCallHistoryAnalysisMinScore}
                    labelCol={3}
                    formCol={6}
                    type="number"
                    value={this.state.data.score_min}   
                    onChange={this.onChange("score_min")}
                    placeholder={langText.Body.EnterValue}
                    min="0"
                    max="999"
                    onKeyDown={e => this.onKeyDownIntCheck(e)}
                    onBlur={() => this.onBlurValidation("score_min")}
                    validationState={this.validationHandle("score_min")}
                    disabled={this.isFormDisabled()}
                />
            </Col>
        );

        // 最大値
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="max-score">
                <InlineForm
                    label={langText.Body.SettingCallHistoryAnalysisMaxScore}
                    labelCol={3}
                    formCol={6}
                    type="number"
                    value={this.state.data.score_max}
                    onChange={this.onChange("score_max")}
                    placeholder={langText.Body.EnterValue}
                    min="0"
                    max="999"
                    onKeyDown={e => this.onKeyDownIntCheck(e)}
                    onBlur={() => this.onBlurValidation("score_max")}
                    validationState={this.validationHandle("score_max")}
                    disabled={this.isFormDisabled()}
                />
            </Col>
        );

        return itemArr;
    }

    getAnalysisSettingDefaultScoreItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="default-score">
                <InlineForm
                    label={langText.Body.SettingCallHistoryAnalysisDefaultScore}
                    labelCol={3}
                    formCol={6}
                    type="number"
                    value={this.state.data.score_base}
                    onChange={this.onChange("score_base")}
                    placeholder={langText.Body.EnterValue}
                    min="0"
                    max="999"
                    onKeyDown={e => this.onKeyDownIntCheck(e)}
                    onBlur={() => this.onBlurValidation("score_base")}
                    validationState={this.validationHandle("score_base")}
                    disabled={this.isFormDisabled()}
                />
            </Col>
        );

        return itemArr;
    }

    getAnalysisSettingTalkTimeScoreItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // 通話時間のスコア設定をテーブル形式で表示
        const talkTimeItems = [
            { key: 'score_talk_minutes_less_than_1', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore1min },
            { key: 'score_talk_minutes_1_to_3', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore1to3min },
            { key: 'score_talk_minutes_3_to_5', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore3to5min },
            { key: 'score_talk_minutes_5_to_10', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore5to10min },
            { key: 'score_talk_minutes_10_to_20', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore10to20min },
            { key: 'score_talk_minutes_20_to_30', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore20to30min },
            { key: 'score_talk_minutes_30_to_40', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore30to40min },
            { key: 'score_talk_minutes_40_to_50', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore40to50min },
            { key: 'score_talk_minutes_50_to_60', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore50to60min },
            { key: 'score_talk_minutes_60_or_more', label: langText.Body.SettingCallHistoryAnalysisTalkTimeScore60min }
        ];

        // 設定可能範囲を計算
        const talkTimeRange = this.calculateTalkTimeRange();

        itemArr.push(
            <Col xs={12} key="talk-time-table">
                <Table bordered hover className="background-white table-center-text call-history-analysis-table">
                    <thead>
                        <tr>
                            <th>{langText.Body.TalkingTime}</th>
                            <th>{langText.Body.SettingValue}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {talkTimeItems.map(item => {
                            const value = this.state.data[item.key];
                            return (
                                <tr key={item.key}>
                                    <td style={{verticalAlign: 'middle'}}>{item.label}</td>
                                    <td>
                                        <InlineForm
                                            type="number"
                                            value={value}
                                            onChange={this.onChange(item.key)}
                                            placeholder={langText.Body.EnterValue}
                                            labelCol={0}
                                            formCol={12}
                                            min={talkTimeRange.min}
                                            max={talkTimeRange.max}
                                            onKeyDown={e => this.onKeyDownIntCheckWithMinus(e)}
                                            onBlur={() => this.onBlurValidation(item.key)}
                                            validationState={this.validationHandle(item.key)}
                                            disabled={this.isFormDisabled()}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Col>
        );

        return itemArr;
    }

    getAnalysisSettingOpRatioItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // OP通話率の目標値
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="op-ratio-target">
                <InlineForm
                    label={
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.SettingCallHistoryAnalysisOpRatioTarget}
                            speechBubbleData={this.props.langText.Message.CallHistoryAnalysisOpRatioTargetInfo}
                            infoIconDisplayFlag={true}
                            infoIconType={faIcon.faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                            custom="speech-bubble-call-history-analysis"
                            placement="right"
                        />
                    }
                    labelCol={4}
                    formCol={4}
                    type="number"
                    value={this.state.data.goal_op_talk_per !== undefined && this.state.data.goal_op_talk_per !== null ? this.state.data.goal_op_talk_per : ""}
                    onChange={this.onChange("goal_op_talk_per")}
                    placeholder={langText.Body.OpTalkTargetPlaceholder}
                    min="0"
                    max="100"
                    onKeyDown={e => this.onKeyDownIntCheck(e)}
                    onBlur={() => this.onBlurValidation("goal_op_talk_per")}
                    validationState={this.validationHandle("goal_op_talk_per")}
                    disabled={this.isFormDisabled()}
                />
            </Col>
        );

        // 目標値から1%離れるごとの減点数
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="op-ratio-score">
                <InlineForm
                    label={
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.SettingCallHistoryAnalysisOpRatioTargetScoreValue}
                            speechBubbleData={this.props.langText.Message.CallHistoryAnalysisOpRatioDeductionInfo.join('\n\n')}
                            infoIconDisplayFlag={true}
                            infoIconType={faIcon.faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                            custom="speech-bubble-call-history-analysis"
                            placement="right"
                        />
                    }
                    labelCol={5}
                    formCol={4}
                    type="number"
                    value={this.state.data.minus_score_op_talk_per_every_1per_deviation !== undefined && this.state.data.minus_score_op_talk_per_every_1per_deviation !== null ? this.state.data.minus_score_op_talk_per_every_1per_deviation : ""}
                    onChange={this.onChange("minus_score_op_talk_per_every_1per_deviation")}
                    placeholder={langText.Body.DeductionScorePlaceholder}
                    min="-999"
                    max="-1"
                    onKeyDown={e => this.onKeyDownIntCheckWithMinus(e)}
                    onBlur={() => this.onBlurValidation("minus_score_op_talk_per_every_1per_deviation")}
                    validationState={this.validationHandle("minus_score_op_talk_per_every_1per_deviation")}
                    disabled={this.isFormDisabled()}
                />
            </Col>
        );

        return itemArr;
    }

    getAnalysisSettingNoSoundCountItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // 無音と判定する秒数
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="no-sound-second">
                                    <InlineForm
                        label={
                            <SetDataWithSpeechBubble
                                displayData={langText.Body.SettingCallHistoryAnalysisNoSoundCountSecond}
                                speechBubbleData={this.props.langText.Message.CallHistoryAnalysisSilenceSecondsInfo}
                                infoIconDisplayFlag={true}
                                infoIconType={faIcon.faInfoCircle}
                                infoIconClassName="modal-info-icon"
                                infoIconColor="silver"
                                infoIconSize="lg"
                                custom="speech-bubble-call-history-analysis"
                                placement="right"
                            />
                        }
                        labelCol={4}
                        formCol={4}
                        type="number"
                        value={this.state.data.seconds_determine_silence !== undefined && this.state.data.seconds_determine_silence !== null ? this.state.data.seconds_determine_silence : ""}
                        onChange={this.onChange("seconds_determine_silence")}
                        placeholder={langText.Body.SecondsPlaceholder}
                        min="0"
                        max="999"
                        onKeyDown={e => this.onKeyDownIntCheck(e)}
                        onBlur={() => this.onBlurValidation("seconds_determine_silence")}
                        validationState={this.validationHandle("seconds_determine_silence")}
                        disabled={this.isFormDisabled()}
                    />
            </Col>
        );

        // 総合評価の減点数
        const isSilenceSecondsZero = this.state.data.seconds_determine_silence === 0;
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="no-sound-score">
                <InlineForm
                    label={
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.SettingCallHistoryAnalysisNoSoundCountScoreValue}
                            speechBubbleData={this.props.langText.Message.CallHistoryAnalysisSilenceDeductionInfo}
                            infoIconDisplayFlag={true}
                            infoIconType={faIcon.faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                            custom="speech-bubble-call-history-analysis"
                            placement="right"
                        />
                    }
                    labelCol={5}
                    formCol={4}
                    type="number"
                    value={isSilenceSecondsZero ? 0 : (this.state.data.minus_score_silence !== undefined && this.state.data.minus_score_silence !== null ? this.state.data.minus_score_silence : "")}
                    onChange={this.onChange("minus_score_silence")}
                    placeholder={isSilenceSecondsZero ? langText.Body.FeatureOffAutoZeroPlaceholder : langText.Body.DeductionScorePlaceholder}
                    min="-999"
                    max="-1"
                    disabled={isSilenceSecondsZero || this.isFormDisabled()}
                    onKeyDown={e => this.onKeyDownIntCheckWithMinus(e)}
                    onBlur={() => this.onBlurValidation("minus_score_silence")}
                    validationState={this.validationHandle("minus_score_silence")}
                />
            </Col>
        );

        return itemArr;
    }

    getAnalysisSettingNoOverlapCountItem = () => {
        let {
            langText
        } = this.props;
        let itemArr = [];

        // 重なりと判定する秒数
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="no-overlap-second">
                                    <InlineForm
                        label={
                            <SetDataWithSpeechBubble
                                displayData={langText.Body.SettingCallHistoryAnalysisNoOverlapCountSecond}
                                speechBubbleData={this.props.langText.Message.CallHistoryAnalysisOverlapSecondsInfo}
                                infoIconDisplayFlag={true}
                                infoIconType={faIcon.faInfoCircle}
                                infoIconClassName="modal-info-icon"
                                infoIconColor="silver"
                                infoIconSize="lg"
                                custom="speech-bubble-call-history-analysis"
                                placement="right"
                            />
                        }
                        labelCol={4}
                        formCol={4}
                        type="number"
                        value={this.state.data.seconds_determine_conflict !== undefined && this.state.data.seconds_determine_conflict !== null ? this.state.data.seconds_determine_conflict : ""}
                        onChange={this.onChange("seconds_determine_conflict")}
                        placeholder={langText.Body.SecondsPlaceholder}
                        min="0"
                        max="999"
                        onKeyDown={e => this.onKeyDownIntCheck(e)}
                        onBlur={() => this.onBlurValidation("seconds_determine_conflict")}
                        validationState={this.validationHandle("seconds_determine_conflict")}
                        disabled={this.isFormDisabled()}
                    />
            </Col>
        );

        // 総合評価の減点数
        const isConflictSecondsZero = this.state.data.seconds_determine_conflict === 0;
        itemArr.push(
            <Col xs={12} md={6} className="margin-top-1" key="no-overlap-score">
                <InlineForm
                    label={
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.SettingCallHistoryAnalysisNoOverlapCountScoreValue}
                            speechBubbleData={this.props.langText.Message.CallHistoryAnalysisOverlapDeductionInfo}
                            infoIconDisplayFlag={true}
                            infoIconType={faIcon.faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                            custom="speech-bubble-call-history-analysis"
                            placement="right"
                        />
                    }
                    labelCol={5}
                    formCol={4}
                    type="number"
                    value={isConflictSecondsZero ? 0 : (this.state.data.minus_score_conflict !== undefined && this.state.data.minus_score_conflict !== null ? this.state.data.minus_score_conflict : "")}
                    onChange={this.onChange("minus_score_conflict")}
                    placeholder={isConflictSecondsZero ? langText.Body.FeatureOffAutoZeroPlaceholder : langText.Body.DeductionScorePlaceholder}
                    min="-999"
                    max="-1"
                    disabled={isConflictSecondsZero || this.isFormDisabled()}
                    onKeyDown={e => this.onKeyDownIntCheckWithMinus(e)}
                    onBlur={() => this.onBlurValidation("minus_score_conflict")}
                    validationState={this.validationHandle("minus_score_conflict")}
                />
            </Col>
        );

        return itemArr;
    }

    render() {
        // データ取得中またはブロッキング状態の判定
        const isLoading = this.state.loading || this.state.blocking;
        
        return (
            <BlockUi tag="div" blocking={isLoading} message={this.props.langText.Body.Wait} keepInView>
                <div>
                    <SetBreadCrumb
                        displayItems={[
                            { link: "/Setting", name: this.props.langText.Body.Setting },
                            { name: this.props.langText.Body.SettingCallHistoryAnalysis },
                        ]}
                    />
                <Row>
                    <Col>
                        {this.getAnalysisSettingCompanyItem()}
                    </Col>
                </Row>
                <Panel bsStyle="info" className="margin-top-05">
                    <Panel.Heading>
                        <Panel.Title>
                            <SetDataWithSpeechBubble
                                displayData={this.props.langText.Body.SettingCallHistoryAnalysisRange}
                                speechBubbleData={this.props.langText.Message.CallHistoryAnalysisRangeInfo}
                                infoIconDisplayFlag={true}
                                infoIconType={faIcon.faInfoCircle}
                                infoIconClassName="modal-info-icon"
                                infoIconColor="silver"
                                infoIconSize="lg"
                                custom="speech-bubble-call-history-analysis"
                                placement="right"
                            />
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingRangeItem()}
                        </Row>
                        {this.renderBlockErrorMessage('range')}
                    </Panel.Body>
                </Panel>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            <SetDataWithSpeechBubble
                                displayData={this.props.langText.Body.SettingCallHistoryAnalysisDefaultScore}
                                speechBubbleData={this.props.langText.Message.CallHistoryAnalysisBaseScoreInfo}
                                infoIconDisplayFlag={true}
                                infoIconType={faIcon.faInfoCircle}
                                infoIconClassName="modal-info-icon"
                                infoIconColor="silver"
                                infoIconSize="lg"
                                custom="speech-bubble-call-history-analysis"
                                placement="right"
                            />
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingDefaultScoreItem()}
                        </Row>
                        {this.renderBlockErrorMessage('base')}
                    </Panel.Body>
                </Panel>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            <SetDataWithSpeechBubble
                                displayData={this.props.langText.Body.SettingCallHistoryAnalysisTalkTimeScore}
                                speechBubbleData={this.props.langText.Message.CallHistoryAnalysisTalkTimeScoreInfo}
                                infoIconDisplayFlag={true}
                                infoIconType={faIcon.faInfoCircle}
                                infoIconClassName="modal-info-icon"
                                infoIconColor="silver"
                                infoIconSize="lg"
                                custom="speech-bubble-call-history-analysis"
                                placement="right"
                            />
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingTalkTimeScoreItem()}
                        </Row>
                        {this.renderBlockErrorMessage('talkTime')}
                    </Panel.Body>
                </Panel>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.SettingCallHistoryAnalysisOpRatio}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingOpRatioItem()}
                        </Row>
                        {this.renderBlockErrorMessage('opRatio')}
                    </Panel.Body>
                </Panel>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.SettingCallHistoryAnalysisNoSoundCount}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingNoSoundCountItem()}
                        </Row>
                        {this.renderBlockErrorMessage('silence')}
                    </Panel.Body>
                </Panel>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.SettingCallHistoryAnalysisNoOverlapCount}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {this.getAnalysisSettingNoOverlapCountItem()}
                        </Row>
                        {this.renderBlockErrorMessage('conflict')}
                    </Panel.Body>
                </Panel>
                {this.props.currentPermission.edit &&
                    <Row>
                        <Col xs={12} className="text-right">
                            <Button
                                className="ok-execute-btn"
                                bsStyle="primary"
                                onClick={this.modalShow()}
                                disabled={this.isUpdateButtonDisabled()}
                            >
                                {this.props.langText.Body.Update}
                            </Button>
                        </Col>
                    </Row>
                }
                {/* 確認モーダル（常時マウントして show の切替で表示制御） */}
                <CallHistoryAnalysisSettingModal
                    state={this.state}
                    propSetState={this.propSetState}
                    langText={this.props.langText}
                    propsState={this.state}
                    onClick={async () => {
                        this.setState({ show : false });
                        await this.onSearch();
                    }}
                    onSave={this.saveSetting}
                />
                </div>
            </BlockUi>
        );
    }
}